import { Option as OptionSynthesisCore } from 'quote-export-manager-core';
import { OptionPricingItem } from '../../../core/models/quote/pricing-item/option-pricing-item';

export class OptionV1Mapper {
  toOption(item: OptionPricingItem): OptionSynthesisCore {
    return new OptionSynthesisCore(
      item.option?.codeElis ?? item.option?.label ?? '',
      item.userInputs?.['quantity'],
      item.precalculatedQuantity ?? '',
      item.option?.appliedPrice,
    );
  }
}
